import React, { useState } from 'react'
import toast from 'react-hot-toast';

function Consultation() {

  const [formData, setFormData] = useState({
    name:'',
    email:'',
    phone:'',
    service:''
  });

  const [loading, setLoading] = useState(false);

  const serviceDescriptions = {
    "IP Chart": "We provide detailed IP chart consultation to help design and configure your electrical systems with precision and compliance.",
    "Panel Information": "Get expert consultation on electrical panel design, sizing, and installation for reliable power distribution.",
    "Busbar Truncking System": "Consult with us for efficient and space-saving busbar trunking system design and implementation.",
    "Main Distribution Box": "Our team will guide you in selecting and configuring main distribution boxes tailored to your project needs.",
    "Lighting Protection System": "We provide consultation on lightning protection systems to safeguard buildings and equipment from surges.",
    "Auto Change Over Panel": "Get professional guidance on auto changeover panels for seamless power backup transitions.",
    "MCC Panel": "Consult with us for Motor Control Center panel design, installation, and maintenance for industrial operations.",
    "Synchronizing Panel": "Our experts offer consultation on synchronizing panels for safe and efficient generator synchronization.",
    "VFD & Soft Starter Panel": "We provide guidance on VFD & soft starter panels to ensure smooth motor control and energy savings.",
    "AC Distribution Box": "Expert consultation on AC distribution box installation for safe and efficient power distribution.",
    "DC Distribution Box": "Our team offers consultation on DC distribution boxes, essential for renewable and industrial systems.",
    "AC Combiner Box": "Consult with us for AC combiner box solutions to optimize solar and renewable energy integrations.",
  };

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value})
  }

  const handleSubmit = async (e) =>{
    e.preventDefault();
    setLoading(true);

    const response = await fetch('https://powerxone.onrender.com/api/consultation/',{
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(formData),
    });

    const result = await response.json();
    if (response.ok) {
      toast.success('Thank you for contacting us!');
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
      });
    } else {
      toast.error('Something went wrong.');
    }
    setLoading(false);
  }

  return (
    <section id="consultation" className="consultation section light-background">
      
      <div className="container section-title" data-aos="fade-up">
        <h2>Consultation Form</h2>
        <div>
          <span>Schedule a&nbsp;</span>
          <span className="description-title">Consultation</span>
        </div>
      </div>
       
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="cta-wrapper">
          <div className="row align-items-center">
            <div className="col-lg-7" data-aos="fade-up" data-aos-delay="200">
              <div className="cta-content">
                <h2>
                  {formData.service 
                    ? `Consultation on ${formData.service}` 
                    : "Ready to Transform Your Business?"}
                </h2>
                <p>
                  {formData.service 
                    ? serviceDescriptions[formData.service] 
                    : "Book a consultation with our experts and let us provide tailored solutions for your electrical and automation needs."}
                </p>
                <div className="cta-stats">
                  <div className="stat-item">
                    <span className="number">
                      <span
                        data-purecounter-start="0"
                        data-purecounter-end="500"
                        data-purecounter-duration="0"
                        className="purecounter"
                      >
                        500
                      </span>+
                    </span>
                    <span className="text">Projects Completed</span>
                  </div>
                  <div className="stat-item">
                    <span className="number">
                      <span
                        data-purecounter-start="0"
                        data-purecounter-end="98"
                        data-purecounter-duration="0"
                        className="purecounter"
                      >
                        98
                      </span>%
                    </span>
                    <span className="text">Client Satisfaction</span>
                  </div>
                  <div className="stat-item">
                    <span className="number">
                      <span
                        data-purecounter-start="0"
                        data-purecounter-end="15"
                        data-purecounter-duration="0"
                        className="purecounter"
                      >
                        15
                      </span>+
                    </span>
                    <span className="text">Years Experience</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-5" data-aos="fade-up" data-aos-delay="300">
              <div className="cta-form">
                <h3>Schedule a Free Consultation</h3>
                <p>
                  Fill out the form below and our team will contact you within
                  24 hours.
                </p>
                <form onSubmit={handleSubmit} className="php-email-form">
                  <div className="form-group">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      className="form-control"
                      placeholder="Your Name"
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group mt-3">
                    <input
                      type="email"
                      value={formData.email}
                      className="form-control"
                      name="email"
                      placeholder="Your Email"
                      required
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group mt-3">
                    <input
                      type="text"
                      className="form-control"
                      name="phone"
                      value={formData.phone}
                      placeholder="Your Phone"
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group mt-3">
                    <select
                      className="form-control"
                      name="service"
                      value={formData.service}
                      required
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Select Service
                      </option>
                      {Object.keys(serviceDescriptions).map((service, index) => (
                        <option key={index} value={service}>
                          {service}
                        </option>
                      ))}
                    </select>
                  </div>
                  
                  <div className="text-center mt-3">
                    <button type="submit" disabled={loading}>
                      {loading ? 'Submitting...' : 'Get Started'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Consultation;
